import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'pulse-chip',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule],
    template: `
        <span class="pulse-chip__label">{{ label() }}</span>
        @if (removable()) {
            <button
                type="button"
                class="pulse-chip__remove"
                [attr.aria-label]="
                    removeLabel() || ('PulseChips.Remove' | translate: { label: label() })
                "
                (click)="removed.emit()"
            ></button>
        }
    `,
    styleUrl: './pulse-chip.component.scss',
    host: {
        class: 'pulse-chip',
    },
})
export class PulseChipComponent {
    readonly label = input.required<string>();

    readonly removable = input(false);

    readonly removeLabel = input('');

    readonly removed = output();
}
